export const speedrunMilestones = [
  {
    id: 1,
    key: "firstBoost",
    name: "Первый Буст Измерений",
    description: "Получите первый Буст Измерений",
    checkRequirement: () => true,
    checkEvent: GAME_EVENT.DIMBOOST_AFTER,
  },
  {
    id: 2,
    key: "firstGalaxy",
    name: "Первая Галактика",
    description: "Получите первую Галактику",
    checkRequirement: () => true,
    checkEvent: GAME_EVENT.GALAXY_RESET_AFTER,
  },
  {
    id: 3,
    key: "firstInfinity",
    name: "Первая Бесконечность",
    description: "Пройдите первую Бесконечность",
    checkRequirement: () => true,
    checkEvent: GAME_EVENT.BIG_CRUNCH_AFTER,
  },
  {
    id: 4,
    key: "completeC9",
    name: "Челленджи Скорости Тика",
    description: "Пройдите Челлендж АвтоПокупщика Скорости Тика",
    checkRequirement: () => NormalChallenge(9).isCompleted,
    checkEvent: GAME_EVENT.BIG_CRUNCH_AFTER,
  },
  {
    id: 5,
    key: "completeAllNC",
    name: "Все Нормальные Челленджи",
    description: "Пройдите все Нормальные Челленджи",
    checkRequirement: () => NormalChallenges.all.countWhere(c => !c.isCompleted) === 0,
    checkEvent: GAME_EVENT.BIG_CRUNCH_AFTER,
  },
  {
    id: 6,
    key: "breakInfinity",
    name: "Преодолеть Бесконечность",
    description: "Преодолейте Бесконечность впервые",
    checkRequirement: () => player.break,
    checkEvent: GAME_EVENT.BREAK_INFINITY,
  },
  {
    id: 7,
    key: "upgrade5e11IP",
    get name() { return `${format(5e11)} Улучшение ОБ`; },
    description: () => `Купите улучшение Галактики на ${formatPercents(0.5)} сильнее`,
    checkRequirement: () => true,
    // This is checked within BreakInfinityUpgrade.onPurchased
  },
  {
    id: 8,
    key: "completeIC5",
    name: "Бесконечный Челлендж 5",
    description: "Пройдите Бесконечный Челлендж 5",
    checkRequirement: () => InfinityChallenge(5).isCompleted,
    checkEvent: GAME_EVENT.BIG_CRUNCH_AFTER,
  },
  {
    id: 9,
    key: "unlockReplicanti",
    name: "Репликанты",
    description: "Разблокируйте Репликантов",
    checkRequirement: () => player.replicanti.unl,
    checkEvent: GAME_EVENT.REPLICANTI_TICK_AFTER,
  },
  {
    id: 10,
    key: "firstEternity",
    name: "Первая Вечность",
    description: "Пройдите первую Вечность",
    checkRequirement: () => true,
    checkEvent: GAME_EVENT.ETERNITY_RESET_AFTER,
  },
  {
    id: 11,
    key: "allEternityMilestones",
    name: "Все Рубежи Вечности",
    description: "Разблокируйте все Рубежи Вечности",
    checkRequirement: () => EternityMilestone.all.every(m => m.isReached),
    checkEvent: GAME_EVENT.ETERNITY_RESET_AFTER,
  },
  {
    id: 12,
    key: "completeFirstEC",
    name: "Первый Вечный Челлендж",
    description: "Пройдите любой уровень Вечного Челленджа",
    checkRequirement: () => EternityChallenges.completions > 0,
    checkEvent: GAME_EVENT.ETERNITY_RESET_AFTER,
  },
  {
    id: 13,
    key: "completeEC10",
    name: "Вечный Челлендж 10",
    description: "Впервые пройдите Вечный Челлендж 10",
    checkRequirement: () => EternityChallenge(10).completions > 0,
    checkEvent: GAME_EVENT.ETERNITY_RESET_AFTER,
  },
  {
    id: 14,
    key: "firstDilation",
    name: "Первая Растянутая Вечность",
    description: "Впервые пройдите Растянутую Вечность",
    checkRequirement: () => player.dilation.active,
    checkEvent: GAME_EVENT.ETERNITY_RESET_BEFORE,
  },
  {
    id: 15,
    key: "upgradeTTgen",
    name: "Генерация Временных Теорем",
    description: "Купите Улучшение Растяжения Генерация Временных Торем",
    checkRequirement: () => true,
    // This is checked within DilationUpgradeState.onPurchased
  },
  {
    id: 16,
    key: "firstReality",
    name: "Первая Реальность",
    description: "Пройдите первую Реальность",
    checkRequirement: () => true,
    checkEvent: GAME_EVENT.REALITY_RESET_AFTER,
  },
  {
    id: 17,
    key: "upgradeBlackHole",
    name: "Чёрная Дыра",
    description: "Разблокируйте Чёрную Дыру",
    checkRequirement: () => true,
    checkEvent: GAME_EVENT.BLACK_HOLE_UNLOCKED,
  },
  {
    id: 18,
    key: "allRealityUpgrades",
    name: "Все Улучшения Реальности",
    description: "Купите все Улучшения Реальности",
    checkRequirement: () => RealityUpgrades.allBought,
    checkEvent: GAME_EVENT.REALITY_UPGRADE_BOUGHT,
  },
  {
    id: 19,
    key: "completeTeresaReality",
    name: "Реальность Терезы",
    description: "Пройдите Реальность Терезы",
    checkRequirement: () => Teresa.isRunning,
    checkEvent: GAME_EVENT.REALITY_RESET_BEFORE,
  },
  {
    id: 20,
    key: "completeEffarigReality",
    name: "Реальность Эффарига",
    description: "Пройдите все уровни Реальности Эффарига",
    checkRequirement: () => Effarig.currentStage === EFFARIG_STAGES.COMPLETED,
    checkEvent: GAME_EVENT.REALITY_RESET_AFTER,
  },
  {
    id: 21,
    key: "completeEnslavedReality",
    name: "Реальность Безымянных",
    description: "Пройдите Реальность Безымянных",
    checkRequirement: () => Enslaved.isRunning,
    checkEvent: GAME_EVENT.REALITY_RESET_BEFORE,
  },
  {
    id: 22,
    key: "complete36VAchievement",
    name: "Все базовые Достижения Ви",
    description: () => `Пройдите ${formatInt(36)} Достижений Ви`,
    checkRequirement: () => true,
    // In order to avoid unnecessary overhead, this is checked within V.checkForUnlocks instead of every tick
  },
  {
    id: 23,
    key: "completeRaMemories",
    name: "Восстановите воспоминания Ра",
    description: "Восстановите все Воспоминания Ра о Божествах",
    checkRequirement: () => Ra.totalPetLevel >= Ra.maxTotalPetLevel,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
  },
  {
    id: 24,
    key: "completeFullDestabilize",
    name: "Полная Дестабилизация",
    description: "Отключите все Измерения внутри Реальности Лай'телы",
    checkRequirement: () => Laitela.isFullyDestabilized,
    // Destabilization isn't a reality reset because it shortcuts gameLoop; this is checked in laitelaRealityTick
  },
  {
    id: 25,
    key: "completeFullGame",
    name: "Игра Пройдена!",
    description: "Пройдите игру целиком",
    checkRequirement: () => Achievement(188).isUnlocked,
    checkEvent: GAME_EVENT.ACHIEVEMENT_UNLOCKED,
  },
];
